import { render, staticRenderFns } from "./AdminComments.vue?vue&type=template&id=c38c9e92&scoped=true&"
import script from "./AdminComments.vue?vue&type=script&lang=js&"
export * from "./AdminComments.vue?vue&type=script&lang=js&"
import style0 from "./AdminComments.vue?vue&type=style&index=0&id=c38c9e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38c9e92",
  null
  
)

export default component.exports